import { setRef as R } from "./SK3NAZA3.js";
import { __spreadValues as c, __spreadProps as v } from "./3YLGPPWQ.js";
import { canUseDOM as l } from "../../../../../../@ariakit_core@0.4.15/node_modules/@ariakit/core/esm/__chunks/DTR5TSDJ.js";
import * as w from "react";
import { useLayoutEffect as M, useEffect as a, useMemo as g, useRef as i, useCallback as E, useState as f, useReducer as L } from "react";
var d = c({}, w), m = d.useId;
d.useDeferredValue;
var p = d.useInsertionEffect, s = l ? M : a;
function C(e) {
  const t = i(e);
  return s(() => {
    t.current = e;
  }), t;
}
function S(e) {
  const t = i(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  return p ? p(() => {
    t.current = e;
  }) : t.current = e, E((...r) => {
    var n;
    return (n = t.current) == null ? void 0 : n.call(t, ...r);
  }, []);
}
function T(e) {
  const [t, r] = f(null);
  return s(() => {
    if (t == null || !e) return;
    let n = null;
    return e((u) => (n = u, t)), () => {
      e(n);
    };
  }, [t, e]), [t, r];
}
function B(...e) {
  return g(() => {
    if (e.some(Boolean))
      return (t) => {
        for (const r of e)
          R(r, t);
      };
  }, e);
}
function D(e) {
  if (m) {
    const n = m();
    return e || n;
  }
  const [t, r] = f(e);
  return s(() => {
    if (e || t) return;
    const n = Math.random().toString(36).slice(2, 8);
    r(`id-${n}`);
  }, [e, t]), e || t;
}
function I(e, t) {
  const r = (o) => {
    if (typeof o == "string")
      return o;
  }, [n, u] = f(() => r(t));
  return s(() => {
    const o = e && "current" in e ? e.current : e;
    u((o == null ? void 0 : o.tagName.toLowerCase()) || r(t));
  }, [e, t]), n;
}
function P(e, t) {
  const r = i(!1);
  a(() => {
    if (r.current)
      return e();
    r.current = !0;
  }, t), a(
    () => () => {
      r.current = !1;
    },
    []
  );
}
function V() {
  return L(() => [], []);
}
function j(e) {
  return S(
    typeof e == "function" ? e : () => e
  );
}
function x(e, t, r = []) {
  const n = E(
    (u) => (e.wrapElement && (u = e.wrapElement(u)), t(u)),
    [...r, e.wrapElement]
  );
  return v(c({}, e), { wrapElement: n });
}
function F(e, t, r) {
  const n = e.onLoadedMetadataCapture, u = g(() => Object.assign(() => {
  }, v(c({}, n), { [t]: r })), [n, t, r]);
  return [n == null ? void 0 : n[t], { onLoadedMetadataCapture: u }];
}
export {
  j as useBooleanEvent,
  S as useEvent,
  V as useForceUpdate,
  D as useId,
  C as useLiveRef,
  B as useMergeRefs,
  F as useMetadataProps,
  s as useSafeLayoutEffect,
  I as useTagName,
  T as useTransactionState,
  P as useUpdateEffect,
  x as useWrapElement
};
//# sourceMappingURL=ABQUS43J.js.map
